import { cva } from "class-variance-authority";

export const homeCardVariants = cva("rounded-2xl", {
  variants: {
    variant: {
      section:
        "border border-slate-200/70 bg-white/90 shadow-[0_6px_24px_-16px_rgba(15,23,42,0.30)] dark:border-zinc-800 dark:bg-zinc-900/85",
      metric:
        "border border-slate-200/70 bg-white/95 shadow-[0_6px_20px_-14px_rgba(15,23,42,0.28)] dark:border-zinc-800 dark:bg-zinc-900/90",
      interactive:
        "border border-slate-200/80 bg-white/95 shadow-[0_8px_24px_-16px_rgba(15,23,42,0.35)] transition-all hover:-translate-y-0.5 hover:shadow-[0_14px_34px_-18px_rgba(15,23,42,0.42)] dark:border-zinc-800 dark:bg-zinc-900/90",
      empty:
        "border-2 border-dashed border-slate-300/90 bg-slate-50/80 dark:border-zinc-700 dark:bg-zinc-900/60",
      loading:
        "border border-slate-200/70 bg-white/80 dark:border-zinc-800 dark:bg-zinc-900/80"
    }
  },
  defaultVariants: {
    variant: "section"
  }
});
